module.exports = __webpack_public_path__ + "static/media/img.search.45fe3a4c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/display/platform/AppStore/AppManage/AppBatchSetPower/UI.SetPower/Icon/img.search.svg
// module id = 1534
// module chunks = 0